
const digest = 'd8c613a81f12c835073af2a8b14ae602f8f207197c73d8d3f3f6d95d4d69f3ce';
const classes = {"wrapper":"_wrapper_shqwa_1","prefix":"_prefix_shqwa_9","input":"_input_shqwa_16"};
const css = `._wrapper_shqwa_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  width: 100%;
}
._wrapper_shqwa_1 ._prefix_shqwa_9 {
  font-weight: 500;
  font-size: 14px;
  position: absolute;
  z-index: 1;
  left: 35px;
}
._wrapper_shqwa_1 ._input_shqwa_16 {
  width: 100%;
}
._wrapper_shqwa_1 ._input_shqwa_16 input {
  padding-left: 40px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  